import React from 'react'
import FallbackLoading from 'components/Loading/Fallback'
import { TopSpacedContainer } from './styles'

function Fallback() {
  return (
    <TopSpacedContainer>
      <FallbackLoading />
    </TopSpacedContainer>
  )
}

export default Fallback
